// Contacts helper functions and data
import { BreadcrumbInfoItem } from "components/global/Breadcrumb/Breadcrumb.types";

export const defaultBreadcrumbContacts: BreadcrumbInfoItem[] = [
  {
    name: "Perfil",
    path: "/profile"
  },
  {
    name: "Contactar con soporte",
    path: "/profile/support"
  },
  {
    name: "Contactos",
    path: "/profile/support/contact-us"
  }
];
